export enum GraphState {
  ShowWarnings = 'ShowWarnings',
  ShowErrorBudgetGraph = 'ShowErrorBudgetGraph',
}
